export default "__VITE_ASSET__59219104__"